import { useEffect } from "react";
import { APP_NAME } from "@/lib/config";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.rel = "canonical"; document.head.appendChild(el); }
  el.href = href;
};

// Per-page title/description/canonical; private app pages are marked noindex.
export const usePageMeta = ({ title, description, index = false }) => {
  useEffect(() => {
    const full = title ? `${title} | ${APP_NAME}` : `${APP_NAME} — AI Rizz & Flirt Reply Assistant`;
    document.title = full;
    setMeta("property", "og:title", full);
    setMeta("name", "twitter:title", full);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("name", "robots", index ? "index, follow, max-image-preview:large" : "noindex, nofollow");
    const url = window.location.origin + window.location.pathname;
    setCanonical(url);
    setMeta("property", "og:url", url);
  }, [title, description, index]);
};
